import styled from '@emotion/styled';
import { ReactNode } from 'react';

const InfoWrapper = styled.div`
    display: flex;
    width: min-content;
    border-radius: 4px;
    background: rgba(9, 6, 4, 0.75);

    position: absolute;
    left: 4px;
    bottom: 4px;

    color: white;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: -0.2px;
`;

const TextWrapper = styled(InfoWrapper)`
    padding: 2px 8px;
`;

const IconWrapper = styled(InfoWrapper)`
    padding: 2px;
`;

interface Props {
    content: string | ReactNode;
}

export const InfoTag = ({ content }: Props) => {
    if (typeof content === 'string') {
        return <TextWrapper>{content}</TextWrapper>;
    }

    return <IconWrapper>{content}</IconWrapper>;
};
